import { render, staticRenderFns } from "./ShowProducto.vue?vue&type=template&id=787f628b"
import script from "./ShowProducto.vue?vue&type=script&lang=ts"
export * from "./ShowProducto.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports